<template lang="pug">
  div#header
    v-container.pa-0(text-xs-center fluid)
      img.header-logo.mt-5(src="../assets/logo.png")
      v-layout(row wrap justify-center)
        v-flex(xs12)
          v-card.h-card.py-4.mb-5(flat)
            h1.py-2.text-sm-center.mb-0.main-color-text.bold Visualiza los casos documentados por CEDEHM en el mapa. 
              br
              span.small Filtra por municipios del estado de Chihuahua o por año de último avistamiento.

</template>

<script>
export default {
  name: "Header",
  props: {}
};
</script>

<style lang="scss">
#header {
  background-color: #fff !important;
  .header-logo {
    max-width: 33vw;
  }
}
#header .h-card {
  padding: 0 8%;
}

h1 {
  line-height: 0.85;
  font-size: 2.5rem;
  span {
    color: #615f5f;
    font-weight: normal;
  }
}
</style>
